import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPage/getError'
import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { mandatoryTag } from '@/containers/SubscriptionFormPageNew/isMandatory'

const TenantType = () => {
  const { tenantTypeOptionsArray, updateAddress, errors, t, tenantType } = useAddress()

  if (!tenantTypeOptionsArray) {
    return null
  }

  return (
    <FormControl
      label={() => (
        <div
          dangerouslySetInnerHTML={{
            __html: mandatoryTag + t('subscriptionForm:address_module.tenant_type'),
          }}
        />
      )}
      error={getError('tenantType', errors)}
    >
      <SDButtonGroup
        onClickHandler={value => updateAddress({ tenantType: value })}
        options={tenantTypeOptionsArray}
        selectedValue={tenantType}
        newTranslations={true}
        translationsPath='subscriptionForm:address_module.tenant_types.'
      />
    </FormControl>
  )
}

export default TenantType
